import React from 'react';
import { Button, Result } from 'antd';

class LazyErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[LazyErrorBoundary] 组件加载失败:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    if (typeof window !== 'undefined') {
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="warning"
          title="页面加载失败"
          subTitle={this.state.error?.message || '组件加载时发生错误，请刷新页面重试'}
          extra={
            <Button type="primary" onClick={this.handleRetry}>
              刷新页面
            </Button>
          }
        />
      );
    }
    return this.props.children;
  }
}

export default LazyErrorBoundary;
